import { render, staticRenderFns } from "./cunlanRecord.vue?vue&type=template&id=625d5700&scoped=true"
import script from "./cunlanRecord.vue?vue&type=script&lang=js"
export * from "./cunlanRecord.vue?vue&type=script&lang=js"
import style0 from "./cunlanRecord.vue?vue&type=style&index=0&id=625d5700&prod&lang=less&scoped=true"
import style1 from "./cunlanRecord.vue?vue&type=style&index=1&id=625d5700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d5700",
  null
  
)

export default component.exports